var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.996 0C5.372 0 0 5.508 0 12.298c-.046 5.23 3.247 9.913 8.204 11.668.609.114.821-.266.821-.604v-2.09c-3.336.743-4.041-1.648-4.041-1.648a3.22 3.22 0 0 0-1.331-1.812c-1.087-.761.085-.75.085-.75.772.12 1.445.589 1.824 1.27 1.068 1.877 2.807 1.334 3.493 1.02a2.682 2.682 0 0 1 .76-1.644c-2.662-.307-5.47-1.364-5.47-6.075a4.814 4.814 0 0 1 1.216-3.305 4.528 4.528 0 0 1 .115-3.25s1.01-.308 3.32 1.28a11.2 11.2 0 0 1 6.009 0c2.292-1.588 3.294-1.256 3.294-1.256a4.5 4.5 0 0 1 .121 3.25 4.814 4.814 0 0 1 1.216 3.304c0 4.723-2.808 5.762-5.47 6.07.584.61.88 1.437.815 2.277v3.37c0 .405.218.712.827.604 4.956-1.761 8.244-6.45 8.19-11.68C24 5.507 18.629 0 11.997 0Z",
    fill: "#FFFBF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.2c53786295795e1c281907bf5e4ab428.svg";
export { ForwardRef as ReactComponent };